export const scGermaniaListDoppelmeisterschaftFinals2026 = {
  "id": "sc-germania-list-doppelmeisterschaft-finals-2026",
  "title": "SC Germania List feiert Doppelmeisterschaft bei den Finals",
  "slug": "sc-germania-list-doppelmeisterschaft-finals-2026",
  "publishedAt": "2026-08-03T09:00:00Z",
  "author": "Rugby Bundesliga Redaktion",
  "language": "de",
  "readTime": "3 min",
  "tags": [
    "Rugby",
    "Bundesliga",
    "7er Rugby",
    "Deutsche Meisterschaft",
    "DIE FINALS",
    "Hannover",
    "SC Germania List",
    "RG Heidelberg"
  ],
  "excerpt": "Der SC Germania List war der große Gewinner der Deutschen Meisterschaft im olympischen 7er Rugby. Bei den Finals in Hannover sicherten sich sowohl die Männer als auch die Frauen des Vereins den deutschen Meistertitel.",
  "img": "/images/sc-germania-list-doppelmeisterschaft-finals-2026.png",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Der SC Germania List war der große Gewinner der Deutschen Meisterschaft im olympischen 7er Rugby. Bei den Finals in Hannover sicherten sich sowohl die Männer als auch die Frauen des Vereins den deutschen Meistertitel. Während die Männer im Finale die RG Heidelberg mit 17 zu 12 bezwangen, setzten sich die Frauen mit 12 zu 7 gegen den SC Neuenheim durch. Damit machte Germania List die Doppelmeisterschaft vor heimischem Publikum perfekt."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Neun Herrenteams kämpfen um den Titel"
    },
    {
      "type": "paragraph",
      "content": "Im Wettbewerb der Männer waren neun Mannschaften angetreten. Die Vorrunde wurde in drei Gruppen mit jeweils drei Teams ausgespielt. Neben den drei Gruppensiegern qualifizierte sich auch der beste Gruppenzweite für das Halbfinale."
    },
    {
      "type": "paragraph",
      "content": "In Gruppe A sicherte sich der SC Frankfurt 1880 mit zwei Siegen den ersten Platz. Nach einem 24 zu 0 gegen den Berliner SV 1892 gewann Frankfurt auch das entscheidende Gruppenspiel gegen den DSV Hannover 78 mit 14 zu 5. Hannover hatte zuvor den Berliner SV mit 22 zu 0 besiegt."
    },
    {
      "type": "paragraph",
      "content": "Die RG Heidelberg startete mit einem deutlichen 29 zu 0 gegen den München RFC in das Turnier. Im zweiten Gruppenspiel entwickelte sich gegen den TSV Handschuhsheim eine wesentlich engere Begegnung. Die RG Heidelberg behielt mit 19 zu 17 knapp die Oberhand und zog als Gruppensieger in das Halbfinale ein. Handschuhsheim sicherte sich durch das anschließende 24 zu 7 gegen München als bester Gruppenzweiter ebenfalls einen Platz unter den besten vier Mannschaften."
    },
    {
      "type": "paragraph",
      "content": "Titelverteidiger SC Germania List dominierte die Gruppe C. Auf das deutliche 40 zu 5 gegen den RK Heusenstamm folgte ein 29 zu 5 gegen den RK 03 Berlin. Heusenstamm belegte durch einen 22 zu 5 Erfolg gegen RK 03 den zweiten Gruppenplatz."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Germania und Heidelberg überzeugen im Halbfinale"
    },
    {
      "type": "paragraph",
      "content": "Im ersten Halbfinale traf der SC Germania List auf den TSV Handschuhsheim. Die Hannoveraner bestimmten die Begegnung und zogen durch einen 24 zu 7 Erfolg erneut in das Endspiel ein."
    },
    {
      "type": "paragraph",
      "content": "Die RG Heidelberg setzte im zweiten Halbfinale ein deutliches Zeichen. Gegen den zuvor ungeschlagenen SC Frankfurt 1880 gewann die RGH mit 45 zu 0 und sicherte sich damit souverän den zweiten Finalplatz."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Erneut 17 zu 12 im Finale"
    },
    {
      "type": "paragraph",
      "content": "Wie bereits bei der Deutschen Meisterschaft 2025 standen sich der SC Germania List und die RG Heidelberg im Endspiel gegenüber. Und erneut endete das Duell mit 17 zu 12 zugunsten der Hannoveraner."
    },
    {
      "type": "paragraph",
      "content": "Germania blieb damit während des gesamten Turniers ungeschlagen und verteidigte erfolgreich den deutschen Meistertitel. In seinen vier Begegnungen erzielte das Team insgesamt 110 Punkte und ließ lediglich 29 Punkte zu. Besonders in der Gruppenphase und im Halbfinale präsentierte sich der Titelverteidiger äußerst dominant. Im Endspiel bewies die Mannschaft schließlich auch in einer engen Partie die notwendige Ruhe."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Frankfurt sichert sich die Bronzemedaille"
    },
    {
      "type": "paragraph",
      "content": "Der SC Frankfurt 1880 sicherte sich den dritten Platz. Nach der deutlichen Niederlage im Halbfinale zeigte Frankfurt im Spiel um Bronze eine starke Reaktion und gewann mit 43 zu 0 gegen den TSV Handschuhsheim."
    },
    {
      "type": "paragraph",
      "content": "Im Spiel um Platz fünf setzte sich der DSV Hannover 78 mit 26 zu 17 gegen den RK Heusenstamm durch. Platz sieben ging an den RK 03 Berlin, der den München RFC in einer engen Begegnung mit 21 zu 17 bezwang. Der Berliner SV 1892 beendete das Turnier auf dem neunten Platz."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Germania Frauen vollenden den Doppelerfolg"
    },
    {
      "type": "paragraph",
      "content": "Auch die Frauen des SC Germania List krönten ihren Turniertag mit dem deutschen Meistertitel. Im Endspiel trafen die Hannoveranerinnen auf den SC Neuenheim."
    },
    {
      "type": "paragraph",
      "content": "In einer engen Finalbegegnung setzte sich Germania List mit 12 zu 7 durch. Damit gingen beide deutschen Meistertitel im olympischen 7er Rugby an den Verein aus Hannover. Die Frauen und Männer des SC Germania List machten gemeinsam die Doppelmeisterschaft bei den Finals 2026 perfekt."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Endplatzierung der Männer"
    },
    {
      "type": "list",
      "items": [
        "SC Germania List",
        "RG Heidelberg",
        "SC Frankfurt 1880",
        "TSV Handschuhsheim",
        "DSV Hannover 78",
        "RK Heusenstamm",
        "RK 03 Berlin",
        "München RFC",
        "Berliner SV 1892"
      ],
      "ordered": true
    }
  ]
};
